import {MediaBrowserPanelTrackingContextState} from '../MediaBrowserPanelTrackingContext';

export type TrackingStage = {
  startTime: number;
  duration: number;
};

export type TrackingStages = {
  processing: TrackingStage;
  files: TrackingStage;
  urls: TrackingStage;
  cache: TrackingStage;
  load: TrackingStage;
};

export type TrackingState = {
  componentCreatedPerformanceMs: number;
  availableFilesReceivedPerformanceMs: number;
  directUrlReceivedPerformanceMs: number;
  dataCachedPerformanceMs: number;
  mediaLoadedPerformanceMs: number;
  panel: MediaBrowserPanelTrackingContextState;
};

export function calculateTrackingStages(
  state: TrackingState
): TrackingStages | null {
  if (!state.mediaLoadedPerformanceMs || !state.panel?.startTimePerformanceMs) {
    return null;
  }

  const panelStartTimePerformance = state.panel.startTimePerformanceMs;

  // Calculate relative start times
  const tileRelativeStartTimeFiles =
    state.componentCreatedPerformanceMs - panelStartTimePerformance;
  const tileRelativeStartTimeUrls =
    state.availableFilesReceivedPerformanceMs - panelStartTimePerformance;
  const tileRelativeStartTimeCache =
    state.directUrlReceivedPerformanceMs - panelStartTimePerformance;
  const tileRelativeStartTimeLoad =
    state.dataCachedPerformanceMs - panelStartTimePerformance;

  // Calculate durations
  const tileDurationProcessing =
    state.componentCreatedPerformanceMs - panelStartTimePerformance;
  const tileDurationFiles =
    state.availableFilesReceivedPerformanceMs -
    state.componentCreatedPerformanceMs;
  const tileDurationUrls =
    state.directUrlReceivedPerformanceMs -
    state.availableFilesReceivedPerformanceMs;
  const tileDurationCache =
    state.dataCachedPerformanceMs - state.directUrlReceivedPerformanceMs;
  const tileDurationLoad =
    state.mediaLoadedPerformanceMs - state.dataCachedPerformanceMs;

  return {
    // NOTE: this lumps a good bit of work into "processing"
    // TODO: add more granular stages for processing to identify where we spend time
    processing: {
      startTime: 0,
      duration: tileDurationProcessing,
    },
    files: {
      startTime: tileRelativeStartTimeFiles,
      duration: tileDurationFiles,
    },
    urls: {
      startTime: tileRelativeStartTimeUrls,
      duration: tileDurationUrls,
    },
    cache: {
      startTime: tileRelativeStartTimeCache,
      duration: tileDurationCache,
    },
    load: {
      startTime: tileRelativeStartTimeLoad,
      duration: tileDurationLoad,
    },
  };
}

export function calculateTotalDuration(state: TrackingState): number | null {
  if (!state.mediaLoadedPerformanceMs || !state.panel?.startTimePerformanceMs) {
    return null;
  }
  return state.mediaLoadedPerformanceMs - state.panel.startTimePerformanceMs;
}
